import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 20, viewBox: "0 -960 960 960", width: 20, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z" }));
export default SvgClose;
